/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { isLastPage } from "selectors/pageNumber";
import { shouldStartRendering, getTotalPages } from "selectors/documentSelectors";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import * as constants from "constants/constants";
import NextPageNavigationIconOld from "dc-icons/consumption/s_page_down_hud_18.svg";
import NextPageNavigationIconModern from "dc-icons/viewer2021/S_ChevronDownMedium_18_N.svg";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";

const mapStoreToProps = (stores, ownProps) => {
  const useModernViewer = getShouldUseModernViewer(stores);
  const shouldDisable = isLastPage(stores) || !shouldStartRendering(stores) || getTotalPages(stores) === 0;
  const props = {
    ...ownProps,
    useModernViewer,
    icon: useModernViewer ? NextPageNavigationIconModern : NextPageNavigationIconOld,
    clickHandler: () => {
      stores.pagedViewState.goToNextPage();
    },
    ariaLabel: useModernViewer ? "modernviewer.arialabel.pageDown" : "arialabel.pageDown",
    tooltipString: useModernViewer ? "modernviewer.tooltip.pageDown" : "tooltip.pageDown",
    tooltipDelay: constants.TOOLTIP_DELAY,
    shouldDisable,
    shouldDisableTooltip: shouldDisable
  };

  return props;
};

const NextPageNavigationContainer = inject(mapStoreToProps)(ButtonWrapper);

export { NextPageNavigationContainer };
